<script setup>
document.documentElement.classList.toggle("dark", false);
</script>

<template>
  <slot />
</template>
